<div class="input">
  <label *ngIf="!!label">
    <span *ngIf="Required" class="required-asterisk">*</span>
    <span>{{ label }}</span>
  </label>
  <div [class]="!isProjectedContentIsSelect?'input-content':'select-content'" [ngClass]="{ 'dateStyle': datePickerStyle }">
    <!-- the select is coming here -->
    <ng-content></ng-content>
  </div>
  <div class="error" *ngIf="ShowError" [ngClass]="{ 'mt-0': datePickerStyle }">
    <validations [control]="control"></validations>
  </div>
</div>
